import { DateTime } from 'luxon';

export const hoursAgo = (date: any) =>
  Math.floor(DateTime.local().diff(DateTime.fromISO(date), 'hours').hours);
